import React from 'react'
import clsx from 'clsx'

import SettingsSection from '../../SettingsSection'

import { FormControlLabel, FormGroup } from '@mui/material'
import { API_TYPE_MAP } from '@SonarCX/utilities/constants'

import Switch from '../../../../components/atoms/Switch'
import useStyles from './styles'

const SETTING_KEY = 'n_enabled_channels'

const mapChannels = (channels, enabled_channels) => {
  return channels.reduce((accumulated, current) => {
    const { id, type, value, name, compliance, validated } = current

    accumulated.push({
      id,
      type,
      value,
      compliance,
      name,
      validated,
      checked:
        !compliance || !validated
          ? false
          : getMappedChannelCheckedValue(id, enabled_channels)
    })
    return accumulated
  }, [])
}

const getMappedChannelCheckedValue = (id, enabled_channels) => {
  if (enabled_channels === undefined) {
    return true
  } else if (enabled_channels.value === '') return false
  else {
    const ids = enabled_channels.value.split(',')
    if (ids.find(i => i === id)) {
      return true
    }
    return false
  }
}

const getChannelLabel = channel => {
  let msg = `${API_TYPE_MAP[channel.type] ?? 'Unknown Type'} ${channel.name} ${
    channel.value
  }`
  if (!channel.validated) {
    return `${msg} (Not Verified) `
  }
  if (!channel.compliance) {
    return (
      <span>
        <label> {msg} </label>
        <label style={{ color: 'red' }}> (Disabled, opted out) </label>
      </span>
    )
  }
  return msg
}

const ChannelSettings = ({ values, setValues, envLoaded, user }) => {
  const [loaded, setLoaded] = React.useState(true)
  const classes = useStyles()

  React.useEffect(() => {
    if (!envLoaded || !user) {
      return
    }

    const channels = [...user.channels]
    const settings = user.settings ?? []
    const enabled_channels = settings.find(
      setting => setting.key === SETTING_KEY
    )
    setValues(mapChannels(channels, enabled_channels))
    setLoaded(true)
  }, [envLoaded, user, setValues])

  const handleChange = React.useCallback(
    channelId => {
      const mutatedValues = values.map(val => {
        if (channelId === val.id) {
          val.checked = !val.checked
        }
        return { ...val }
      })
      setValues(mutatedValues)
    },
    [values, setValues]
  )

  if (values.length === 0) return null
  return (
    <SettingsSection title='Channels' loaded={loaded && envLoaded}>
      {values.map(option => {
        return (
          <FormGroup key={option.id} className={classes.switchGroup}>
            <FormControlLabel
              className={clsx([
                classes.switch,
                (!option.compliance || !option.validated) && classes.disabled
              ])}
              label={getChannelLabel(option)}
              control={
                <Switch
                  checked={option.checked}
                  onChange={() => handleChange(option.id)}
                  disabled={!option.compliance || !option.validated}
                />
              }
            />
          </FormGroup>
        )
      })}
    </SettingsSection>
  )
}

export default ChannelSettings
